import { Anchor, Badge, Button, Group, Table, Text } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';

import { useJourneys } from '../api/hooks';
import { DataState } from '../components/DataState';
import { PageHeader } from '../components/PageHeader';
import { StatusBadge } from '../components/StatusBadge';
import { fmtRelative } from '../theme/format';

export function JourneysPage() {
  const { data, isLoading, error } = useJourneys();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        title="Journeys"
        description="Multi-step, conditional sends. A run that is already in flight keeps executing the version it started on, so editing a live journey never changes what happens to someone halfway through it."
        action={
          <Button leftSection={<IconPlus size={16} />} onClick={() => navigate('/journeys/new')}>
            New journey
          </Button>
        }
      />

      <DataState
        loading={isLoading}
        error={error}
        empty={!data?.length}
        emptyTitle="No journeys yet"
        emptyDescription="Welcome series, cart abandonment, re-engagement — anything with a wait or a condition in it."
        action={<Button onClick={() => navigate('/journeys/new')}>Build one</Button>}
      >
        <Table.ScrollContainer minWidth={760}>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Name</Table.Th>
                <Table.Th>Trigger</Table.Th>
                <Table.Th>Status</Table.Th>
                <Table.Th>Entry</Table.Th>
                <Table.Th>Updated</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data?.map((j) => (
                <Table.Tr key={j.id}>
                  <Table.Td>
                    <Group gap={6}>
                      <Anchor component={Link} to={`/journeys/${j.id}`} fw={500} size="sm">
                        {j.name}
                      </Anchor>
                      {j.dry_run && (
                        <Badge size="xs" color="blue" variant="light">dry run</Badge>
                      )}
                    </Group>
                  </Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed" ff="monospace">
                      {j.trigger.type === 'event'
                        ? `on ${j.trigger.name}`
                        : j.trigger.type === 'segment_enter'
                          ? 'on entering a segment'
                          : 'manual'}
                    </Text>
                  </Table.Td>
                  <Table.Td><StatusBadge status={j.status} /></Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed">
                      {j.entry_rule}
                      {j.entry_cap ? ` · max ${j.entry_cap}` : ''}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed">{fmtRelative(j.updated_at)} · v{j.version}</Text>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </DataState>
    </>
  );
}
